import { Component, EventEmitter, OnInit,Output } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-common-confirmation-modal',
  templateUrl: './common-confirmation-modal.component.html',
  styleUrls: ['./common-confirmation-modal.component.scss']
})
export class CommonConfirmationModalComponent implements OnInit {

  authoringContentData: any;
  action: any;
  message: any;
  header: any;
  ctaAllow: any;
  ctaCancel: any;
  ctaClose: any;
  @Output() isYesButtonClicked = new EventEmitter<boolean>();

  constructor(private _utilSvc: UtilsService, public manageLineService: ManageLineService) { }

  ngOnInit(): void {
    this.authoringContentData = this._utilSvc.getContentDataFromSession();
    if(!this.action){
      this.ctaAllow = this.authoringContentData.common_authoring.iotConfirmationYes;
      this.ctaCancel = this.authoringContentData.common_authoring.iotConfirmationNo;
    }
  }

  onClickYes(){
    this.isYesButtonClicked.emit(true);
  }

  close() {
    if(this.ctaClose){
    this.isYesButtonClicked.emit(true);
    this.manageLineService.close();
    }else{
      this.isYesButtonClicked.emit(false);
    }
   
  }

}
